export default "__VITE_ASSET__e51e254c__"